









































































import Vue from 'vue';
import axios from 'axios';
import VariableInput from '@/components/util/VariableInput.vue';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import { checkUserId, signUp } from '@/api/Login';
import {
  mailAddressConstraintErrorMessage,
  mailAddressLengthLimit,
  mailAddressRegExp,
  passwordConstraintMessage,
  passwordConstraintErrorMessage, 
  passwordRegExp, 
  userIdConstraintMessage,
  userIdConstraintErrorMessage, 
  userIdRegExp,
} from './constraint';
import { ErrorResponse } from '@/api/dto/Error';

export default Vue.extend({
  name: 'Signup',
  components: {
    VariableInput,
    // PasswordInput,
    FooterSimple,
  },
  mounted() {
    this.loadGoogleAdsTag();
  },
  beforeDestroy() {
    this.removeGoogleAdsTag();    
  },
  watch: {
    /**
     * 入力値変更時にバリデーション
     */
    'accountData.id'(userId: string) {
      this.signupInputs['id'].ok = '';
      this.signupInputs['id'].error = userIdRegExp.test(userId) ? '' : userIdConstraintErrorMessage;
      this.checkUserId(userId);
    },
    'accountData.mail'(mailAddress: string) {
      this.signupInputs['mail'].error = mailAddressRegExp.test(mailAddress) && mailAddress.length <= mailAddressLengthLimit
        ? '' : mailAddressConstraintErrorMessage;
    },
    'accountData.password'(password: string) {
      this.signupInputs['password'].error = passwordRegExp.test(password) ? '' : passwordConstraintErrorMessage;
    },
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.isAvailableId && userIdRegExp.test(this.accountData.id)
        && (this.accountData.mail.length <= mailAddressLengthLimit && mailAddressRegExp.test(this.accountData.mail)) 
        && passwordRegExp.test(this.accountData.password) && !this.isApiProcessing);
    },
  },
  data() {
    return {
      accountData: {
        id: '',
        mail: '',
        password: '',
      },
      signupInputs: {
        // ユーザーID重複が無い時は ok にメッセージを入れる
        id: { name: 'ID', type: 'text', placeholder: 'ID', constraint: userIdConstraintMessage, error: '', ok: '' },
        mail: { name: 'メールアドレス', type: 'text', constraint: mailAddressConstraintErrorMessage, placeholder: 'メールアドレス', error: '' },
        password: { name: 'パスワード', type: 'password', constraint: passwordConstraintMessage, placeholder: 'パスワード', error: '' },
      },
      isAvailableId: true,
      submitModal: false,
      errorMessage: '',
      isApiProcessing: false,
      accountType: '1',
    }
  },
  methods: {
    loadGoogleAdsTag() {
      const tagId = 'AW-11231687905';
      if (!document.getElementById('revma-google-tag')){
        const script = document.createElement('script');
        script.id = 'revma-google-tag';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
        document.head.appendChild(script);
      }

      const win = window as any;
      win.dataLayer = win.dataLayer || [];
      win.gtag = win.gtag || function() {
        win.dataLayer.push(arguments);
      };
      win.gtag('js', new Date());
      win.gtag('config', tagId)
    },
    removeGoogleAdsTag() {
      const script = document.getElementById('revma-google-tag');
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }

      const win = window as any;
      delete win.gtag;
      delete win.dataLayer;
    },
    async onClickSignUp() {
      if(!this.isAvailableId){
        return;
      }
      this.isApiProcessing = true;
      try{
        await signUp({
          userId: this.accountData.id, 
          mailAddress: this.accountData.mail, 
          password: this.accountData.password,
          accountType: this.accountType,
        });
        this.submitModal = true;
      }catch(e){
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
            if (resError.message != null) {
              this.$emit('errorToast', resError.message);
            }
        }
      }
      this.isApiProcessing = false;
    },
    /**
     * ユーザーID重複チェックをし, それに応じたメッセージを設定する
     */
    async checkUserId(userId: string) {
      if (!userIdRegExp.test(userId)) {
        return;
      }
      const res = await checkUserId({ userId });
      this.isAvailableId = res.isAvailable;
      if (res.isAvailable) {
        this.signupInputs['id'].error = '';
        this.signupInputs['id'].ok = res.message;
      } else {
        this.signupInputs['id'].error = res.message;
      }
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
  }
})
